import axios from 'axios'

const instance = axios.create({
 baseURL:'http://209.126.5.100:88/api',
// baseURL:'http://localhost/api',
 //baseURL:'https://localhost:44326/api',
})
export default instance
// /  baseURL: 'http://162.250.125.195:88/api',npm
  

//Main URL 
// baseURL:'http://209.126.5.100:88/api',
//Globals for Main 
// {
//       "apiURL": "http://209.126.5.100:88",
//     "mainURL": "http://209.126.5.100",
//     "imageURL": "http://209.126.5.100:88/images/",
//     "mobileNo": "9203041290023"
//   }

